import React from 'react';

const PopularDiscussions = () => {
  const discussions = [
    {
      id: 1,
      title: "Vos meilleurs jeux réalisés avec MakeCode Arcade",
      category: "Projets Makers",
      icon: "🔥",
      comments: 42,
      likes: 87,
      author: "SarahK",
      authorAvatar: "SK",
      timestamp: "2 heures",
      isPinned: false,
      isHot: true
    },
    {
      id: 2,
      title: "Mon premier robot avec micro:bit : besoin de conseils !",
      category: "Questions & Entraide",
      icon: "📌",
      comments: 24,
      likes: 35,
      author: "RobotFan",
      authorAvatar: "RF",
      timestamp: "5 heures",
      isPinned: true,
      isHot: false
    },
    {
      id: 3,
      title: "Quelles applis utilisez-vous pour apprendre en équipe ?",
      category: "Apprentissage & Tutorat",
      icon: "💡",
      comments: 31,
      likes: 49,
      author: "LearnTogether",
      authorAvatar: "LT",
      timestamp: "1 jour",
      isPinned: false,
      isHot: true
    },
    {
      id: 4,
      title: "Retour en images sur le Summer Camp GoNextMaker 2025",
      category: "Ateliers & Événements",
      icon: "🎉",
      comments: 56,
      likes: 102,
      author: "NextMakerTeam",
      authorAvatar: "NT",
      timestamp: "3 jours",
      isPinned: false,
      isHot: true
    }
  ];

  return (
    <section className="py-12 px-4 md:px-8 lg:px-16 bg-light-5">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-title font-bold text-dark-1 mb-2 font-sans">
          Discussions récentes & populaires
        </h2>
        <p className="text-light-1 mb-8 font-sans text-normal">
          Découvrez les conversations qui animent la communauté en ce moment
        </p>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {discussions.map((discussion) => (
            <div 
              key={discussion.id} 
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 border border-light-3"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center">
                  <span className="text-2xl mr-3">{discussion.icon}</span>
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                    discussion.isPinned ? 'bg-yellow-100 text-yellow-800' : 
                    discussion.isHot ? 'bg-red-100 text-red-800' : 
                    'bg-blue-100 text-blue-800'
                  }`}>
                    {discussion.category}
                  </span>
                </div>
                {discussion.isPinned && (
                  <svg className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M5.5 17.5a.5.5 0 01-1 0V2.914l-.646-.647a.5.5 0 01.708-.708l1.5 1.5a.5.5 0 010 .708l-1.5 1.5a.5.5 0 01-.708-.708L4.5 3.914V17.5zM15.5 2.5a.5.5 0 011 0v14.586l.646.647a.5.5 0 01-.708.708l-1.5-1.5a.5.5 0 010-.708l1.5-1.5a.5.5 0 01.708.708l-.646.647V2.5z" />
                  </svg>
                )}
              </div>
              
              <h3 className="text-lg font-semibold text-dark-1 mb-3 font-sans hover:text-purple-1 cursor-pointer">
                {discussion.title}
              </h3>
              
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center">
                  <div className="w-8 h-8 rounded-full bg-purple-3 flex items-center justify-center text-purple-1 font-medium text-sm mr-2">
                    {discussion.authorAvatar}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-dark-1">{discussion.author}</p>
                    <p className="text-xs text-light-1">{discussion.timestamp}</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="flex items-center text-light-1">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm">{discussion.comments}</span>
                  </div>
                  <div className="flex items-center text-light-1">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
                    </svg>
                    <span className="text-sm">{discussion.likes}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8">
          <button className="bg-red-4 hover:bg-white text-white hover:text-red-4 font-sans py-3 px-6
          rounded-full transition-colors duration-300 border-2 border-red-4">
            Voir toutes les discussions
          </button>
        </div>
      </div>
    </section>
  );
};

export default PopularDiscussions;